export default "__VITE_ASSET__IFZfs6Z3__"